<template>
  <div>
    <el-collapse>
      <div style="height:100%">
        <el-collapse v-model="activeName" accordion>
          <el-collapse-item
            :title="index==0?'当前订单':'追加订单'+index"
            v-for="(item,index) in data.orderDTOList"
            :key="index"
            :name="index"
          >
            <div class="span-in">
              <span>桌位：{{item.tcNo}}号,</span>
              <span>订单编号：{{item.id}},</span>
              <span>订单时间：{{item.rowCrtTs|formatDate('yyyy-MM-dd hh:mm:ss')}},</span>
              <span>订单状态: {{option[item.status]}},</span>
              <span>总数量：{{item|compNum}},</span>
              <span>总金额：{{item|compMoney}}元</span>
            </div>
            <div style="margin:10px 0" class="verification" v-if="item.status!=8">
              <el-button type="primary" size="mini" v-if="item.status!=4" @click="agren(item)">重发订单</el-button>
            </div>
            <el-table size="mini" :data="item.goodsList" border style="width: 100%">
              <el-table-column type="index" label="序号" width="50px"></el-table-column>
              <el-table-column prop="gdName" label="菜品名称"></el-table-column>
              <el-table-column prop="gdNum" label="数量">
                <template slot-scope="scope">
                  <el-input-number
                    @change="change"
                    :min="0"
                    :max="scope.row.maxGdNum"
                    size="mini"
                    v-model="scope.row.gdNum"
                    :disabled="status==8"
                  ></el-input-number>
                </template>
              </el-table-column>
              <el-table-column prop="gdAmt" label="单价">
                <template slot-scope="scope">{{(scope.row.gdAmt/100).toFixed(2)}} 元</template>
              </el-table-column>
              <el-table-column label="合计">
                <template
                  slot-scope="scope"
                >{{((scope.row.gdAmt*scope.row.gdNum)/100).toFixed(2)}} 元</template>
              </el-table-column>
              <el-table-column prop="ordermemo" label="菜品备注">
              </el-table-column>
            </el-table>
            <p style="margin-top:10px;">订单备注:{{item.memo}}</p>
          </el-collapse-item>
        </el-collapse>
      </div>
    </el-collapse>
    <div style="margin:10px 0 0">
      <span>共计：{{data.orderDTOList.length}}单 ,</span>
      <span>数量：{{data.oldGdNum}} ,</span>
      <span>订单总金额：{{(data.orderAmt/100).toFixed(2)}}元 ,</span>
      <span style="color:rgb(2, 16, 212)">应付金额：{{(data.orderAmt/100).toFixed(2)}}元 。</span>
    </div>
    <br>
    <div style="text-align:center">
      <el-button
        size="mini"
        type="primary"
        v-show="status!=8"
        :loading="dialogFormVisible"
        @click="sub()"
      >确认调整</el-button>
      <el-button size="mini" type="primary" v-show="status!=8" @click="ok()">现金付款</el-button>
      <el-button size="mini" type="primary" v-show="status==8" @click="Confirm()">确认下单</el-button>
      <el-button size="mini" type="primary" v-show="status==8" @click="closefirm()">取消订单</el-button>
    </div>
    <el-dialog title="重新打印" :visible.sync="Visible" :append-to-body="true" width="320px">
      <el-form :model="formD" size="mini">
        <el-form-item label="发送:">
          <el-radio-group v-model="formD.usage">
            <el-radio :label="1">前台打印机</el-radio>
            <el-radio :label="2">后厨打印机</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="Visible = false">取 消</el-button>
        <el-button size="mini" type="primary" :loading="fasongTogg" @click="fasong">发送</el-button>
      </div>
    </el-dialog>
    <el-dialog title="现金付款" :visible.sync="payment" :append-to-body="true" width="520px">
      <el-form
        :model="Cash"
        :rules="rules"
        size="mini"
        ref="ruleForm2"
        label-width="120px"
        :label-position="left"
      >
        <el-form-item label="应付金额:">
          <span>￥{{Cash.shouldPayAmt}}</span>
        </el-form-item>
        <el-form-item label="抹零:" prop="disAmt">￥
          <el-input class="h100" v-model="Cash.disAmt"></el-input>
        </el-form-item>
        <el-form-item label="应收金额:">
          <span>￥{{Cash.shouldReceiveAmt}}</span>
        </el-form-item>
        <el-form-item label="实际支付金额:" prop="actualPayAmt">￥
          <el-input class="h100" v-model="Cash.actualPayAmt" @change="actual"></el-input>
        </el-form-item>
        <el-form-item label="找零:">
          <span>￥{{Cash.changeAmt}}</span>
        </el-form-item>
        <el-form-item label="实收金额:">
          <span>￥{{Cash.payAmt}}</span>
        </el-form-item>
        <el-form-item label="收款备注:">
          <textarea
            placeholder="请输入抹零原因，限50字"
            style="width:300px;height:120px"
            class="textzin"
            maxlength="50"
            v-model="receiptMemo"
          ></textarea>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align:center">
        <el-button size="mini" type="primary" @click="determine">确定</el-button>
        <el-button size="mini" @click="payment= false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as math from "mathjs";

export default {
  props: ["data", "load", "newList"],
  created() {
    this.sum = this.Sum();
    this.data.oldGdNum = this.data.goodsNum;
    this.status = this.data.orderDTOList[0].status;
    this.receipts = this.data.orderAmt;
  },
  data() {
    var kongge = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("必填"));
      } else {
        let str = /^([1-9][\d]{0,7}|0)(\.[\d]{1,2})?$/;
        if (!str.test(value)) {
          callback(new Error("请输入正确的金额"));
        } else {
          callback();
        }
      }
    };
    var kongge_w = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("必填"));
      } else {
        let str = /^([1-9][\d]{0,7}|0)(\.[\d]{1,2})?$/;
        if (!str.test(value)) {
          callback(new Error("请输入正确的金额"));
        } else  if(+this.Cash.disAmt > +this.Cash.shouldPayAmt){
          callback(new Error("抹零不能大于应付金额"));
        }else{
          callback();
        }
      }
    };
    return {
      left: "left",
      yezi: "",
      status: "",
      fasongTogg: false,
      Visible: false,
      receipts: "",
      formD: {
        usage: 1
      },
      isPayBefore: localStorage.getItem("isPayBefore"),
      dialogFormVisible: false,
      activeName: 0,
      sum: 0,
      option: {
        0: "待支付",
        1: "待支付",
        2: "支付成功",
        3: "支付失败",
        4: "已取消",
        8: "待确认"
      },
      item: {},
      payment: false,
      receiptMemo: "",
      Cash: {
        shouldPayAmt: "",
        payAmt: "",
        actualPayAmt: "",
        shouldReceiveAmt: "",
        changeAmt: "0.00",
        disAmt: "",
        receiptMemo: "",
        id: ""
      },
      rules: {
        actualPayAmt: [
          { required: true, message: "必填", trigger: "blur" },
          { validator: kongge, trigger: "blur" }
        ],
        disAmt: [
          { required: true, message: "必填", trigger: "blur" },
          { validator: kongge_w, trigger: "change" }
        ]
      },
      form:{
        toAdjustOGNumList:[]
      }
    };
  },
  filters: {
    compNum(item) {
      let num = 0;
      for (let i of item.goodsList) {
        num += i.gdNum;
      }
      return num;
    },
    compMoney(item) {
      let sum = 0;
      for (let i of item.goodsList) {
        sum += i.gdNum * i.gdAmt;
      }
      return (sum / 100).toFixed(2);
    }
  },
  watch: {
    "Cash.disAmt"(val) {
      // if (+val > +this.Cash.shouldPayAmt) {
      //   console.log(typeof val, 1, typeof this.Cash.shouldPayAmt);
      //   this.$notify.error({
      //     message: "不能大于应付金额"
      //   });
      //   this.Cash.payAmt = "0.00";
      //   this.Cash.shouldReceiveAmt = "0.00";
      // } else {
        let shouldPayAmt = math.bignumber(this.Cash.shouldPayAmt).toString();
        let disAmt = math.bignumber(val).toString();
        this.Cash.payAmt = math.subtract(shouldPayAmt, disAmt).toFixed(2);
        this.Cash.shouldReceiveAmt = math
          .subtract(shouldPayAmt, disAmt)
          .toFixed(2);
        if (this.Cash.actualPayAmt != "") {
          this.Cash.changeAmt = math
            .subtract(this.Cash.actualPayAmt, this.Cash.payAmt)
            .toFixed(2);
        }
      // }
    }
  },
  methods: {
    actual(val) {
      if (val == "") {
        this.Cash.changeAmt = "0.00";
      }
      if (+val < +this.Cash.payAmt) {
        this.$notify.error({
          message: "收款金额不能小于应收金额"
        });
      } else {
        let actualPayAmt = math.bignumber(val).toString();
        let payAmt = math.bignumber(this.Cash.payAmt).toString();
        this.Cash.changeAmt = math.subtract(actualPayAmt, payAmt).toFixed(2);
      }
    },
    fasong() {
      this.fasongTogg = true;
      this.$http
        .post(
          `/w/businessStatus/reSendOrder/${this.item.id}/${this.formD.usage}`,
          this.item
        )
        .then(
          data => {
            this.$message.success("发送成功！");
            this.fasongTogg = false;
            this.Visible = false;
          },
          err => {
            this.fasongTogg = false;
          }
        );
    },
    Sum() {
      var sum = 0,
        num = 0;
      console.log(this.data.orderDTOList);
      for (let i = 0; i < this.data.orderDTOList.length; i++) {
        let obj = this.data.orderDTOList[i];
        for (let j = 0; j < obj.goodsList.length; j++) {
          let data = obj.goodsList[j];
          num += data.gdNum;
          sum += data.gdAmt * data.gdNum;
        }
      }
      this.data.goodsNum = num;
      return sum;
    },
    Price() {
      var sum = 0,
        num = 0;
      for (let i = 0; i < this.data.orderDTOList.length; i++) {
        let obj = this.data.orderDTOList[i];
        for (let j = 0; j < obj.goodsList.length; j++) {
          let data = obj.goodsList[j];
          num += data.gdNum;
          sum += data.gdAmt * data.gdNum;
        }
      }
      this.data.goodsNum = num;
      return num;
    },
    Confirm() {
      let id = this.data.orderId;
      this.$http.post(`/w/businessStatus/confirmOrder?orderId=${id}`).then(
        data => {
          this.$message({
            type: "success",
            message: "确认下单成功"
          });
          this.load();
          this.$emit("close");
        },
        err => {}
      );
    },
    closefirm() {
      let id = this.data.orderId;
      this.$http.post(`/w/businessStatus/cancelOrder?orderId=${id}`).then(
        data => {
          this.$message({
            type: "success",
            message: "取消订单成功"
          });
          this.load();
          this.$emit("close");
        },
        err => {}
      );
    },
    change(a) {
      this.data.orderAmt = this.Sum();
      this.data.oldGdNum = this.Price();
    },
    sub() {
      this.dialogFormVisible = true;
      let data = [];
      for (let i = 0; i < this.data.orderDTOList.length; i++) {
        let obj={};
          obj.orderId=this.data.orderDTOList[i].id;
          obj.goodsList=this.data.orderDTOList[i].goodsList;
        // let obj = {
        //   orderId: this.data.orderDTOList[i].id,
        //   goodsList: this.data.orderDTOList[i].goodsList
        // };
        data.push(obj);
      }
      let orderId = data[0].orderId;
      this.form.toAdjustOGNumList=data;
      this.$http.post(`/w/orderGoods/adjust/${orderId}`, this.form).then(
        data => {
          this.$message({
            type: "success",
            message: "调整成功"
          });
          this.form.toAdjustOGNumList.goodsList=[];
          this.form.toAdjustOGNumList.orderId='';
          this.$emit("close");
          this.receipts = this.data.orderAmt;
          this.dialogFormVisible = false;
        },
        err => {
          this.dialogFormVisible = false;
        }
      );
    },
    close() {
      this.$emit("close");
    },
    ok() {
      this.$refs["ruleForm2"] &&
        this.$refs["ruleForm2"].resetFields &&
        this.$refs["ruleForm2"].resetFields();
      this.payment = true;
      this.Cash.changeAmt = "0.00";
      this.Cash.shouldPayAmt = (this.receipts / 100).toFixed(2);
      let disAmtz = this.Cash.shouldPayAmt.split(".");
      this.Cash.disAmt = 0 + "." + disAmtz[1];
      let shouldPayAmt = math.bignumber(this.Cash.shouldPayAmt).toString();
      let disAmt = math.bignumber(this.Cash.disAmt).toString();
      this.Cash.payAmt = math.subtract(shouldPayAmt, disAmt).toFixed(2);
      this.Cash.shouldReceiveAmt = math
        .subtract(shouldPayAmt, disAmt)
        .toFixed(2);
    },
    determine() {
      this.$refs["ruleForm2"].validate(valid => {
        if (valid) {
          if (this.Cash.actualPayAmt < +this.Cash.payAmt) {
            this.$notify.error({
              message: "收款金额不能小于应收金额"
            });
          } else {
            let data = {};
            for (let i in this.Cash) {
              data[i] = math.round(this.Cash[i] * 100);
            }
            data.id = this.data.orderDTOList[0].id;
            data.receiptMemo = this.receiptMemo;
            this.$http.post(`/w/order/cashPay`, { ...data }).then(
              d => {
                this.$emit("load");
                this.$emit("close");
                this.$message({
                  type: "success",
                  message: "操作成功！"
                });
              },
              e => {
                this.$message.error("操作失败！");
              }
            );
          }
        } else {
          return false;
        }
      });
    },
    agren(item) {
      this.formD.usage = 1;
      this.Visible = true;
      this.item = item;
      return;
      this.$confirm("是否确认重新发送?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "成功!"
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    }
  }
};
</script>

<style scoped>
.verification {
  width: 80px;
  height: 30px;
  background: #409eff;
  font-size: 12px;
  border-radius: 3px;
  line-height: 30px;
  text-align: center;
  color: white;
  display: inline-block;
  margin: 10px 0;
}
.span-in > span {
  display: inline-block;
}
.h100 {
  width: 130px;
}
.textzin {
  width: 300px;
  height: 120px;
  border-radius: 5px;
  border: 1px solid #c0c4cc;
}
</style>


// WEBPACK FOOTER //
// src/view/page/operatingState/dialogDetails.vue